<template>
  <div class="row">
    <div class="col-12">
      <div class="p-3 float-end">
        <b-button
          variant="primary"
          @click="postModalOpen"
        >
          {{ $t('modal.nameModalPost') }}
        </b-button>
      </div>
    </div>

    <div class="col-12">
      <div class="_table mb-3">
        <b-table class="fs-5"
          :fields="fields"
          :items="data"
        >
          <template #cell(actions)="{item}">
            <b-button class="me-3"
              variant="success"
              size="sm"
              @click="putModalOpen(item.id)"
            >
              <i class="bx bx-pencil fs-4"></i>
            </b-button>

            <b-button class="me-3"
              variant="danger"
              size="sm"
              @click="deleteModalOpen(item.id)"
            >
              <i class="bx bx-trash fs-4"></i>
            </b-button>

            <b-button
              variant="primary"
              size="sm"
              @click="onRouter(item.id)"
            >
              <i class="bx bx-list-ul fs-4"></i>
            </b-button>
          </template>
        </b-table>
      </div>
    </div>

    <b-pagination
      v-model="pagination.page"
      :total-rows="total"
      :per-page="pagination.pageSize"
      @input="getData"
    ></b-pagination>

    <b-modal
      v-model="postModalBool"
      hide-footer
      :title="$t('modal.titlePost')"
    >
      <PostModal
        @onClose="postModalClose"
      />
    </b-modal>

    <b-modal
      v-model="putModalBool"
      hide-footer
      :title="$t('modal.titleDelete')"
      size="lg"
    >
      <PutModal
        :id="id"
        @onClose="putModalClose"
      />
    </b-modal>

    <b-modal
      v-model="deleteModalBool"
      hide-footer
      :title="$t('modal.titleDelete')"
    >
      <DeleteModal
        :id="id"
        @onClose="deleteModalClose"
      />
    </b-modal>
  </div>
</template>

<script>
  import PostModal from './postModal.vue';
  import DeleteModal from './DeleteModal.vue';
  import PutModal from './putModal.vue';
  // import { getPermissions } from '../../../api/endpoints/permissions';
  import {getRoles} from '../../../api/endpoints/roles'

  export default {
    name: 'RolesVue',
    components: {
      DeleteModal,
      PostModal,
      PutModal
    },
    data() {
      return {
        postModalBool: false,
        putModalBool: false,
        deleteModalBool: false,
        permissions_options: [],
        id: null,
        fields: [{
            key: "id",
            label: this.$t('table.id.label')
          },
          {
            key: "name",
            label: this.$t('table.name.label')
          },
          {
            key: "actions",
            label: this.$t('table.actions.label'),
            class: "d-flex"
          }
        ],
        pagination: {
          page: 1,
          perPage: 15
        },
        data: [],
        total: 1,
      }
    },
    mounted() {
      this.getData();
      // this.getPermissionsForSelect();
    },
    methods: {
      // getPermissionsForSelect() {
      //   getPermissions({all: true}).then( res => {
      //     this.permissions_options = res.data.data.map( item => item.name)
      //   })
      // },
      /*-----------------*/
      postModalOpen() {
        this.postModalBool = true;
      },
      postModalClose() {
        this.postModalBool = false;
        this.getData();
      },
      putModalOpen(id) {
        this.id = id;
        this.putModalBool = true;
      },
      putModalClose() {
        this.getData()
        this.putModalBool = false;
      },
      deleteModalOpen(id) {
        this.id = id;
        this.deleteModalBool = true;
      },
      deleteModalClose() {
        this.getData();
        this.deleteModalBool = false;
      },
      getData() {
        getRoles(this.pagination).then( res => {
          this.data = res.data.data;
          this.total = res.data.total
        })
      },
      onRouter(id) {
        this.$router.push("/management/roles/" + id);
      }
    }
  }
</script>
